import React from 'react';
import './HeroSection.css';
import {
  FaSearch,
  FaBriefcase,
  FaFileContract,
  FaPaperPlane,
} from 'react-icons/fa';

function HeroSection() {
  return (
    <section className='hero-section'>
      <div className='hero-wrapper'>
        <div className='item-1 hero-item'>
          <div className='search-wrapper'>
            <FaSearch className='search-icon' />
            <FaBriefcase className='briefcase-icon' />
          </div>
        </div>
        <div className='item-2 hero-item'>
          <FaPaperPlane className='icon' />
        </div>
        <div className='item-3 hero-item'>
          <FaFileContract className='icon' />
        </div>
      </div>
      <div className='hero-text'>
        <h2 className='hero-title'>הדבר הבא:</h2>
        <h2 className='hero-title'>קרוב מתמיד</h2>

        <div className='divider'></div>
        <p className='hero-subtitle'>השינוי שייחלת לו מחכה לך</p>
      </div>
    </section>
  );
}

export default HeroSection;
